import { Typography } from "@mui/material";
import UserHQLocationDashBoardDesktop from "../components/desktop/user-hq-location-dashboard/UserHQLocationDashBoardDesktop";

const UserHQLocationDashBoard = () => {
  return (
    <>
      <UserHQLocationDashBoardDesktop />
    </>
  );
};

export default UserHQLocationDashBoard;
